import { IMenuItemActionRoleActions } from 'types/layout';
import { IRecordType } from 'types/recordType';

export const filterRecordTypesByPermissions = (
    recordTypeList: IRecordType[],
    roleId?: number | null,
    checkPermissionFn?: (recordTypeId: number, roleId?: number) => IMenuItemActionRoleActions[]
) => {
    if (!checkPermissionFn || !roleId) return recordTypeList;

    const filteredList: IRecordType[] = [];

    for (const recordType of recordTypeList) {
        const permissions = checkPermissionFn(+recordType.id, roleId);
        const hasAccess = permissions?.find(({ name }) => name.toLowerCase() === 'access')?.enabled;
        if (hasAccess) filteredList.push(recordType);
    }
    return filteredList;
};
